import { $api } from '../y/api';
import { YId, YFlags } from '../y/types';
import { CBookingAdminView } from './c-booking-admin';
import { CProducer } from './c-producer';
import { CUser } from './c-user';

export interface CUserProducerView extends CUser {
    producer_roles: CUserProducerRole[];
    as_user_token: string;
}

export type CProducerRole = 'admin' | 'economy' | 'events' | 'bookings';

export interface CUserProducerRole {
    user_id: YId;
    producer_id: YId;
    roles: YFlags<CProducerRole>;
}

export interface CUserProducerRoleUserView extends CUserProducerRole {
    user_first_name: string;
    user_last_name: string;
    user_email: string;
}

export interface CProducerRoleInvite {
    id: YId;
    src_user_id: YId;
    dst_email: string;
    token: string;
    producer_id: YId;
    roles: YFlags<CProducerRole>;
}

export interface CProducerRoleInviteUserView extends CProducerRoleInvite {
    src_user_first_name: string;
    src_user_last_name: string;
    src_user_email: string;
}

let all_producer_users_promise: Promise<CUserProducerView[]> | undefined;

export function cProducerUsersGetAll(refresh?: boolean) {
    if(!all_producer_users_promise || refresh) {
        return $api.GET<CUserProducerView[]>('c/users/producer_view');
    }

    return all_producer_users_promise;
}

interface ProducerRolesResponse {
    roles: CUserProducerRoleUserView[];
    invites: CProducerRoleInviteUserView[];
}

export function cProducerRolesGet(producer_id: YId) {
    return $api.GET<ProducerRolesResponse>(`c/producer/${producer_id}/roles`);
}

export function cProducerRoleDelete(producer_id: YId, user_id: YId) {
    return $api.DELETE(`c/producer/${producer_id}/role/${user_id}`);
}

export function cProducerRoleUpdate(role: CUserProducerRole, roles: YFlags<CProducerRole>) {
    return $api.PUT(`c/producer/${role.producer_id}/role/${role.user_id}`, { roles }).then(() => {
        role.roles = roles;
    });
}

export function cProducerBookingsWithPurchases(producer: YId) {
    return $api.GET<CBookingAdminView[]>(`producer/${producer}/bookings_with_purchases`).catch($api.errorHandler);
}

export function cProducerUpdateEventDefaults(producer: CProducer, data: any) {
    return $api.PUT<CProducer>(`producer/${producer.id}/event_defaults`, data).catch($api.errorHandler)
}
